import LocalStorage from '../../../helpers/LocalStorage';
import ExplosivePrecursorFormValidation from './ExplosivePrecursorFormValidation';
import RecieverForm from '../shared/RecieverForm';
import formFields from './json/formFields.json';

/**
 * Explosive Precursors review class
 */
export default class ExplosivePrecursorReview {
    constructor(validThroughDate) {
        this.storageName = 'explosivePrecursors';
        this.validation = new ExplosivePrecursorFormValidation();
        this.storage = new LocalStorage();
        this.RecieverForm = new RecieverForm('explosives');
        this.validThroughDate = validThroughDate;
        this.payload = {};
        this.formFields = formFields;
        this.InitEventListerners();
    }

    /**
     * Event Listerners
     */
    InitEventListerners() {
        this.recieverEventListerner('.step2');
        this.recieverEventListerner('.step1');

        // Store data when form change
        for (const formItem of document.querySelectorAll('.explosiveForm')) {
            formItem.addEventListener('change', () => {
                this.storeData();
            });
        }
    }

    /**
     * Set Reciever data when fields change
     * @param {*} step 
     */
    recieverEventListerner(step) {
        for (let item of document.querySelectorAll(step)) {
            item.addEventListener('change', () => {
                this.setRecieverFieldsFromInput();
            });
        }
    }

    /**
     * Store data
     */
    storeData() {
        this.setRecieverFieldsFromInput();

        for (const item of document.querySelectorAll('.explosiveForm')) {
            if (item.type !== 'checkbox') {
                this.payload[item.id] = item.value ? item.value : null;
            }
        }
        this.storage.setItem(this.storageName, this.payload);
        this.validation.checkForm('reciever');
    }

    /**
     * Setting payload from Helper
     * @param {*} payLoadData
     */
    preparePayLoad(payLoadData) {
        const attrKey = Object.keys(payLoadData)[0];
        const attrValue = payLoadData[attrKey];
        this.payload[attrKey] = attrValue;
        this.storeData();
    }

    /**
     * Set Review data for payload from Form input/Interaction
     */
    setRecieverFieldsFromInput() {
        for (let key in this.formFields) {
            const fieldElementId = formFields[key].fields.id;
            const fieldElement = document.querySelector(fieldElementId);

            if (formFields[key].type === 'checkbox') {
                if (fieldElement.checked) {
                    document
                        .querySelector(formFields[key].fields.selectedClass)
                        .classList.remove('hidden');

                    document.querySelector(formFields[key].fields.reviewId).innerHTML =
                        '<span class="material-icons md-dark">check_box</span>';

                    if (
                        document.querySelectorAll(`${formFields[key].fields.groupClass}:checked`)
                            .length < 2
                    ) {
                        document
                            .querySelector(formFields[key].fields.nextSelectedClass)
                            .classList.add('hidden');
                    }
                }

                this.payload[key] = fieldElement.checked;
            }

            if (formFields[key].type === 'text') {
                document.querySelector(formFields[key].fields.reviewId).innerHTML =
                    fieldElement.value;
                this.payload[key] = fieldElement.value;
            }
        }

        // Email
        // ---------------------------------------------
        this.payload.emailAddress = document.querySelector('#emailAddress').value;

        // End date
        // ---------------------------------------------------------------------
        this.payload.validThroughDate = this.validThroughDate;

        this.storage.setItem(this.storageName, this.payload);
    }

    /**
     * Get payLoad data
     * @returns {} Object
     */
    getPayload() {
        return this.payload;
    }
}
